export const Documents = {
    TermsAndConditionsUrl: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL,
    PrivacyPolicyUrl: import.meta.env.VITE_PRIVACY_POLICY_URL
}

export const Constants = {
    LocationSearchKey: import.meta.env.VITE_LOCATION_SEARCH_KEY
}